import { groq } from 'next-sanity'
import { createIconImageProjection } from './createIconImageProjection'

import { LocaleId } from '@aether/configs'

export const createJournalPictogramProjection = (localeId: LocaleId) => groq`{
      image${createIconImageProjection(localeId)}
    }
  `
